export interface Task {
    id: number
    title: string
    description: string
    status: string
    dueDate: Date
    assigneeID: string
    leadID: number
    orgID: string
    createdAt: Date
    updatedAt: Date
    assignee: any
    lead: any
}

// 'TODO', 'IN_PROGRESS', 'DONE', 'EXPIRED'
export enum TaskStatus {
    TODO = 'TODO',
    IN_PROGRESS = 'IN_PROGRESS',
    DONE = 'DONE'
}